import React from 'react'

/**
 * Page controls for a chart that would otherwise grow without bound.
 *
 * Renders nothing when everything already fits on one page -- controls that can
 * never do anything are noise.
 *
 * The range label names the rank explicitly ("1-10 of 34 users"), because the
 * data is sorted largest-first and the reader needs to know they are looking at
 * the top of a ranking rather than an arbitrary slice.
 */
const Pager = ({ page, pageCount, setPage, start, count, total, unit = 'rows' }) => {
    if (pageCount <= 1) return null

    return (
        <div className="viz-pager">
            <span className="viz-pager-range">
                {start + 1}-{start + count} of {total} {unit}, ranked by volume
            </span>
            <div className="viz-pager-controls">
                <button
                    type="button"
                    className="viz-pager-button"
                    onClick={() => setPage(page - 1)}
                    disabled={page === 0}
                    aria-label="Previous page"
                >
                    <i className="fa fa-chevron-left" aria-hidden="true"></i>
                </button>
                <span className="viz-pager-position">
                    Page {page + 1} of {pageCount}
                </span>
                <button
                    type="button"
                    className="viz-pager-button"
                    onClick={() => setPage(page + 1)}
                    disabled={page >= pageCount - 1}
                    aria-label="Next page"
                >
                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    )
}

export default Pager
